import * as React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import * as actions from '../model/ui/actions'
import { State } from '../model'
import { GlobalStyles, ThemeProvider } from '@design/pt-ui'
import { ToastContainer } from 'react-toastify'
import '../themes/reactToastify.css'

import { EnvToggleButton } from './env'
import Layout from './Main'
import InfoPage from '../pages/Page/InfoPage'
import MainTheme from '../themes/Light'

import NotificationContainer from '../components/NotificationContainer'
import { ContextProvider as DirtySanchezProvider } from '../components/DirtySanchez'
import { IAppError } from '../interfaces/base'
import { appErrorFromAnything } from '../utils/error'

import './App.css'
import { translateWithUserLocale } from '../utils/i18n'

const TOAST_BODY_CLASS = 'cp-toast-body'

const globalStyles = {
  '.cp-app': {
    height: '100%',
    fontFamily: "'Nunito', sans-serif",
  },
  '.cp-app input': {
    margin: 0,
    border: 0,
    padding: '10px 10px',
    display: 'inline-block',
    verticalAlign: 'middle',
    whiteSpace: 'normal',
    background: 'none',
    lineHeight: 1,
    fontSize: '16px',
    fontFamily: "'Nunito', sans-serif",
  },
  '.cp-app input:disabled': {
    color: '-internal-light-dark-color(rgb(84, 84, 84), rgb(170, 170, 170))',
  },
  '.cp-app input:focus': {
    outline: '0  !important',
    borderColor: 'transparent !important',
    boxShadow: 'none  !important',
    WebkitBoxShadow: 'none  !important',
    MozBoxShadow: 'none  !important',
  },
  '.cp-app h1, .cp-app h2, .cp-app h3, .cp-app h4, .cp-app h5, .cp-app h6': {
    fontWeight: 800,
    margin: 0,
    padding: 0,
    fontFamily: "'Nunito', sans-serif",
  },
  '.cp-app p': {
    fontFamily: "'Nunito', sans-serif",
  },
  '.cp-app img': {
    maxWidth: '100%',
    height: 'auto',
  },
  '.cp-app button[class*="Pagination-arrowButton"]': {
    padding: 0,
  },
  '.cp-app div[class*="PageSizeSelector"]': {
    paddingTop: '0 !important',
  },
  [`.${TOAST_BODY_CLASS}`]: {
    fontSize: '12px',
    fontFamily: "'Nunito', sans-serif",
    color: '#fff',
    fontWeight: 600,
    wordBreak: 'break-word' as const,
  },
}

interface IApp {
  env: string
  catchError: (error: IAppError) => void
  error: IAppError | null
}
class App extends React.PureComponent<IApp> {
  public componentDidCatch(error: any) {
    this.props.catchError(appErrorFromAnything(error))
  }

  public render() {
    const { env = 'production' } = this.props
    const theme = MainTheme

    const content =
      this.props.error != null ? (
        <InfoPage
          title={this.props.error.statusCode}
          heading={this.props.error.title}
          description={this.props.error.message}
        />
      ) : (
        <Layout />
      )

    return (
      <div className="cp-app">
        <GlobalStyles styles={globalStyles} />
        <DirtySanchezProvider
          leavePromptMessage={translateWithUserLocale(
            'warning.unsaved_changes',
          )}>
          <ThemeProvider theme={theme}>
            <ToastContainer
              theme="colored"
              toastClassName={TOAST_BODY_CLASS}
              autoClose={5000}
              newestOnTop={true}
            />
            <NotificationContainer>
              {content}

              {env === 'development' ? <EnvToggleButton /> : null}
            </NotificationContainer>
          </ThemeProvider>
        </DirtySanchezProvider>
      </div>
    )
  }
}

const mapStateToProps = (state: State) => {
  return {
    error: state.ui.error,
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    catchError: (err: IAppError) => dispatch(actions.error(err)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)
